import React, { ReactElement, useEffect, useState } from "react";
import { Controller } from "react-hook-form";

export type RadioGroupProps<T> = {
  items: T[];
  renderItems: (item: T, isSelected: boolean, index: number) => ReactElement;
  name: string;
  control: any;
  value?: any;
  defaultValue?: T | {};
  ignoreClick?: boolean;
  wrapperClassName?: string;
  itemWrapperClassName?: string;
};

export const RadioGroup = <T,>(props: RadioGroupProps<T>) => {
  const {
    items,
    control,
    name,
    renderItems,
    value,
    defaultValue,
    ignoreClick,
    wrapperClassName,
    itemWrapperClassName,
  } = props;
  const [selectedItem, setSelectedItem] = useState<T | {} | null>();

  useEffect(() => {
    if (defaultValue) {
      setSelectedItem(defaultValue);
    }
  }, [defaultValue]);

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange } }): ReactElement => {
        return (
          <div className={wrapperClassName}>
            {items.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${itemWrapperClassName ? itemWrapperClassName : ""}`}
                  onClick={() => {
                    if (!ignoreClick) {
                      if (value && selectedItem === item) {
                        setSelectedItem(null);
                        onChange(null);
                      } else {
                        setSelectedItem(item);
                        onChange(item);
                      }
                    }
                  }}
                >
                  {renderItems(item, selectedItem === item, index)}
                </div>
              );
            })}
          </div>
        );
      }}
    />
  );
};
